import { useEffect, useState } from "react";
import CONFIGURACIONES from "../../../util/constants";

import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { Functions } from "../../../helpers/Functions";
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";
import { Http } from "../../../helpers/Http";
import MantCargosAreaEmployee from "./components/MantCargosAreaEmployee.jsx";
const MySwal = withReactContent(Swal);

const PageCargosAreaEmployee = () => {
    const location = useLocation();


    const [isRenderList, setIsRenderList] = useState(CONFIGURACIONES.INIT.STATUS_RENDER_LIST);
    // const [idEdit, setIdEdit] = useState(CONFIGURACIONES.INIT.ID_EDIT);
    const [idRef, setIdRef] = useState(CONFIGURACIONES.INIT.ID_EDIT);
    const [areas, setAreas] = useState(CONFIGURACIONES.INIT.ARRAY);
    const [cargos, setCargos] = useState(CONFIGURACIONES.INIT.ARRAY);
    const [iconActive, setIconActive] = useState(CONFIGURACIONES.INIT.STRING);

    const { getUser } = useOutletContext();
    const { showSpinnerLoader } = useOutletContext();

    const createDataPermissionComponent = async (form) => {
        // form['usuario_registro'] = getUser();
        await Functions().save(`${CONFIGURACIONES.ENDPOINTS.AREAS_EMPLEADO}/cargos/guardar`, CONFIGURACIONES.MESSAGES.SUCCESS_OPERATION, getUser(), loadData, {'areas': form});
    };
    const loadData = () => {
        Http().post(`${CONFIGURACIONES.ENDPOINTS.AREAS_EMPLEADO}/cargos`).then((rpta) => {
            if (rpta.status === CONFIGURACIONES.RESPONSES.SUCCESS) {
                setAreas(rpta.data.areas);
            }
        });
    };

    const searchPermissions = (action) => {
        let permisoStorage = localStorage.getItem('option_id');
        let tienePermiso = CONFIGURACIONES.INIT.STATUS_FALSE
        if (permisoStorage) {
            let permiso_id = Functions().decryptData(permisoStorage);
            tienePermiso = Functions().searchPermissions(permiso_id, action, getUser().permisos);
        }

        return tienePermiso;
    };

    useEffect(() => {
        const icon = localStorage.getItem('icon_active');
        if (icon) {
            const icon_decrypt = Functions().decryptData(icon);
            setIconActive(icon_decrypt);
        }
    }, []); // se ejecuta una vez al montar

    useEffect(() => {
        if (!searchPermissions(CONFIGURACIONES.ACTIONS.MOSTRAR)) { return; }

        showSpinnerLoader();
        loadData();
        let segments = location.pathname.split("/");
        let lastSegment = segments[segments.length - 1];
        console.log('lastSegment', lastSegment);
        setIsRenderList(CONFIGURACIONES.INIT.STATUS_RENDER_LIST);

    }, [location.pathname])

    return (
        <div className="content-wrapper">
            <div className="content-body">
                <div className="row">
                    {isRenderList && (
                        <div className="col-lg-10 col-md-12 col-xs-12">
                            <div className="card">
                                <div className="card-body">
                                    <MantCargosAreaEmployee title={'Gestión de Cargos por Área de Empleado'} idEdit={idRef} closeSection={loadData} MySwal={MySwal} idRef={idRef}
                                                             setIdRef={setIdRef} createData={createDataPermissionComponent} areas={areas} cargos={cargos} icon={iconActive}
                                                             showCreate={searchPermissions(CONFIGURACIONES.ACTIONS.CREAR)} showEdit={searchPermissions(CONFIGURACIONES.ACTIONS.ACTUALIZAR)}/>
                                </div>
                            </div>
                        </div>
                    )}

                </div>
            </div>
        </div>
    )
}

export default PageCargosAreaEmployee;